import { useQuery } from '@tanstack/react-query';
import { api, type AgentProfile } from '@/lib/api';
import { useSession } from '@/lib/auth-client';

export function useCurrentAgent() {
  const { data: session } = useSession();

  return useQuery({
    queryKey: ['currentAgent'],
    queryFn: async () => {
      const response = await api.get<AgentProfile>('/agents/me');
      if (!response.success) {
        throw new Error(response.error?.message || 'Failed to fetch current agent');
      }
      return response.data!;
    },
    enabled: !!session?.user,
  });
}
